import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Scene from '../3D/Scene';

// Pàgina AMB escena 3D (com Home): l'escena 3D NOMÉS s'inicia a Home i About. Sobreescriu
// _sceneBeforeShow (no amaga el render com Default; l'inicia). A DIFERÈNCIA de Home, About NO fa
// directShow del sea → es queda a UNDERWATER (split 1). Si About té un billboard_sea, ja farà ell
// la transició de show quan entri; si no, es manté underwater.
export default class About extends Default {
  _sceneBeforeShow() {
    Scene.seabedEnabled = true; // fons marí al footer (l'scroll-item del footer el crea a Scroll.init)
    WebGLSketch.start();
    Scene.start();                       // guardat: pren el control del render el 1r cop; arrenca a underwater
    if (!this.isFirstTime) Scene.show(); // tornem (no 1r cop): fade in del canvas
    Scene.hideRender();                  // About = UNDERWATER: assegura el sea fora (split → 1), també si hi arribem amb split 0
    if (this.isFirstTime) Scene.directShowSea(); // init per About: mar directament als settings finals (sense entrada animada)
  }
}

ControllerPage._addPage('about', About);
